function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M44.3333 7H11.6667C9.08934 7 7 9.08934 7 11.6667V44.3333C7 46.9107 9.08934 49 11.6667 49H44.3333C46.9107 49 49 46.9107 49 44.3333V11.6667C49 9.08934 46.9107 7 44.3333 7Z",
  stroke: "#F2F4F7",
  strokeWidth: 2.43478,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M19.835 23.3324C21.768 23.3324 23.335 21.7654 23.335 19.8324C23.335 17.8994 21.768 16.3324 19.835 16.3324C17.902 16.3324 16.335 17.8994 16.335 19.8324C16.335 21.7654 17.902 23.3324 19.835 23.3324Z",
  stroke: "#F2F4F7",
  strokeWidth: 2.43478,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M48.9984 34.9991L37.3317 23.3324L11.665 48.9991",
  stroke: "#F2F4F7",
  strokeWidth: 2.43478,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgImage = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgImage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/image.8c461e4c.svg";
export { ForwardRef as ReactComponent };